import React, { useState } from 'react';
import Header from '../../components/Layout/Header/Header';
import { contactService } from '../../api/api.service';
import '../../pages/contactpage/ContactPage.css';
import { PhoneOutlined, MailOutlined, EnvironmentOutlined } from '@ant-design/icons';

const ContactPage: React.FC = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    subject: '',
    message: '',
  });

  const [statusMessage, setStatusMessage] = useState('');
  const [isSending, setIsSending] = useState(false);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsSending(true);
    setStatusMessage('');

    try {
      const fd = new FormData();
      fd.append('your-name', formData.name);
      fd.append('your-email', formData.email);
      fd.append('your-subject', formData.subject);
      fd.append('your-message', formData.message);

      // ✅ Required CF7 hidden fields
      fd.append('_wpcf7', '9079810'); // your form ID
      fd.append('_wpcf7_version', '5.9.6'); // check your CF7 plugin version
      fd.append('_wpcf7_locale', 'en_US');
      fd.append('_wpcf7_unit_tag', 'wpcf7-f9079810-o1');
      fd.append('_wpcf7_container_post', '0');

      const result = await contactService.submitContactForm(fd);
      console.log('CF7 Response:', result);

      if (result.status === 'mail_sent') {
        setStatusMessage('✅ Your message has been sent successfully!');
        setFormData({ name: '', email: '', subject: '', message: '' });
      } else {
        setStatusMessage('❌ Error sending message. Please check your fields.');
      }
    } catch (error) {
      console.error('Error:', error);
      setStatusMessage('❌ Something went wrong. Please try again later.');
    } finally {
      setIsSending(false);
    }
  };

  return (
    <>
      <Header />
      <div className="contact-page">
        <div className="contact-header">
          <h1>Contact</h1>
          <p>Lifestyle Online Sites / Lifestyle Online / Contact</p>
        </div>

        <div className="contact-info">
          <div className="info-box">
            <div className="icon-box">
              <PhoneOutlined />
            </div>
            <div>
              <h4>Phone</h4>
              <p>+91 99424 50631</p>
            </div>
          </div>

          <div className="info-box">
            <div className="icon-box">
              <MailOutlined />
            </div>
            <div>
              <h4>E-Mail</h4>
              <p>jeevantech@gmail.com</p>
            </div>
          </div>

          <div className="info-box">
            <div className="icon-box">
              <EnvironmentOutlined />
            </div>
            <div>
              <h4>Location</h4>
              <p>Coimbatore, India</p>
            </div>
          </div>
        </div>

        <div className="contact-container">
          <h2><span className="underlined-word">Send Message</span></h2>
          <div className="wavy-line"></div>

          <form onSubmit={handleSubmit} className="contact-form">
            <div className="form-row">
              <input
                type="text"
                name="name"
                placeholder="Your name"
                value={formData.name}
                onChange={handleChange}
                required
              />
              <input
                type="email"
                name="email"
                placeholder="Email address"
                value={formData.email}
                onChange={handleChange}
                required
              />
            </div>

            <input
              type="text"
              name="subject"
              placeholder="Subject"
              value={formData.subject}
              onChange={handleChange}
              required
            />

            <textarea
              name="message"
              placeholder="Your message here..."
              value={formData.message}
              onChange={handleChange}
              required
            ></textarea>

            <button type="submit" className="submit-btn" disabled={isSending}>
              {isSending ? 'Sending...' : 'Submit Message'}
            </button>
          </form>

          {statusMessage && <p className="status-msg">{statusMessage}</p>}
        </div>
      </div>
    </>
  );
};

export default ContactPage;
